export enum FundDocumentTypes {
  FUND_FACTSHEET = 'Fund Factsheet',
  PRODUCT_HIGHLIGHT_SHEET = 'Product Highlight Sheet',
  ANNUAL_REPORT = 'Annual Report',
  SEMI_QUARTER_REPORT = 'Semi / Quarter Report',
  FUND_PROSPECTUS_INFO_MEMO = 'Fund Prospectus / Info Memo',
  SUPPLEMENTARY_PROSPECTUS_INFO_MEMO = 'Supplementary Prospectus / Info Memo',
}
